/** Also shown when card status is unknown, so it must not claim the patient has no card. */
export const PAYMENT_METHOD_MESSAGE_DRAFT =
    'Hi, please add or confirm your payment method in your patient portal so I can process your payment. Thank you.';
